export const getLoading = state => state.loading;
export const getTac = state => state.result;




// WEBPACK FOOTER //
// ./src/redux/tac/selectors.js